import React, { useEffect, useState } from "react";
import ActionList from "./components/ActionList";
import CompanyHeader from "components/CompanyHeader";
import CompanySideMenu from "components/CompanySideMenu";
import {useDispatch} from "react-redux";
import {ThunkDispatch} from "@reduxjs/toolkit";
import {getListOptionsRelatedAction} from "reducers/action";
import Copyright from "../../components/Copyright";

const ActionManagement = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    // Get options related talent
    dispatch(getListOptionsRelatedAction(""));
  }, []);

  return (
    <>
      <CompanyHeader />
      <div className="mt-6 px-6 flex gap-6 relative">
        <CompanySideMenu />
        <div className="flex-1">
          <h1 className="mb-4 text-xl font-bold leading-[1.875rem] alu-text-base-2">
            アクション管理
          </h1>
          <p className="mb-6 text-sm alu-text-base-1">
            応募、スカウト後の選考状況を記録します。<br/>担当者を登録し、選考が進んだ場合にはステータスを更新して記録をしてください。
          </p>
          <div>
            <ActionList />
          </div>
        </div>
      </div>
      <Copyright view="company" />
    </>
  );
};

export default ActionManagement;
